import { render, staticRenderFns } from "./SettingsCompanyView.vue?vue&type=template&id=4dc11891&scoped=true&"
import script from "./SettingsCompanyView.vue?vue&type=script&lang=js&"
export * from "./SettingsCompanyView.vue?vue&type=script&lang=js&"
import style0 from "./SettingsCompanyView.vue?vue&type=style&index=0&id=4dc11891&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc11891",
  null
  
)

export default component.exports